import { Link } from "react-router-dom";
import { Clock, AlertTriangle, TimerOff } from "lucide-react";

const formatStatus = (s) =>
  (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const AlertBanners = ({ staleLeads, duplicateAlerts, expiringSoon, getStatusColor }) => (
  <div className="space-y-3 mb-6">
    {/* Stale Leads Warning */}
    {staleLeads.length > 0 && (
      <div className="bg-red-50 border border-red-200 p-4" data-testid="stale-leads">
        <div className="flex items-center gap-2 mb-3">
          <Clock className="w-5 h-5 text-red-600" />
          <h3 className="font-['Outfit'] font-bold text-red-800 text-sm">
            {staleLeads.length} Stale Lead{staleLeads.length !== 1 ? "s" : ""} — No action for 48h+
          </h3>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {staleLeads.map((lead) => (
            <div key={lead.quote_id} className="bg-white border border-red-100 p-3 flex items-center justify-between">
              <div className="min-w-0">
                <div className="font-medium text-sm text-[#0F172A] truncate">{lead.customer?.name || "Unknown"}</div>
                <div className="text-xs text-slate-500 truncate">{lead.from_postcode} → {lead.to_postcode}</div>
              </div>
              <span className={`text-xs font-medium px-2 py-0.5 rounded shrink-0 ml-2 ${getStatusColor(lead.status)}`}>
                {formatStatus(lead.status)}
              </span>
            </div>
          ))}
        </div>
      </div>
    )}

    {/* Duplicate Alerts */}
    {duplicateAlerts.length > 0 && (
      <div className="bg-amber-50 border border-amber-200 p-4" data-testid="duplicate-alerts">
        <div className="flex items-center gap-2 mb-3">
          <AlertTriangle className="w-5 h-5 text-amber-600" />
          <h3 className="font-['Outfit'] font-bold text-amber-800 text-sm">
            Repeat Enquiries (last 14 days)
          </h3>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {duplicateAlerts.map((alert) => (
            <div key={alert.customer_id} className="bg-white border border-amber-100 p-3 flex items-center justify-between">
              <div className="min-w-0">
                <div className="font-medium text-sm text-[#0F172A] truncate">{alert.name}</div>
                <div className="text-xs text-slate-500 truncate">{alert.email}</div>
              </div>
              <span className="text-xs font-bold bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full shrink-0 ml-2">
                {alert.quote_count} quotes
              </span>
            </div>
          ))}
        </div>
      </div>
    )}

    {/* Expiring Soon */}
    {expiringSoon.length > 0 && (
      <div className="bg-orange-50 border border-orange-200 p-4" data-testid="expiring-soon">
        <div className="flex items-center gap-2 mb-3">
          <TimerOff className="w-5 h-5 text-orange-600" />
          <h3 className="font-['Outfit'] font-bold text-orange-800 text-sm">
            {expiringSoon.length} Quote{expiringSoon.length !== 1 ? "s" : ""} Expiring Soon — Act within 2 days
          </h3>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {expiringSoon.map((quote) => (
            <Link
              key={quote.quote_id}
              to="/admin/quotes?status=estimated"
              className="bg-white border border-orange-100 p-3 flex items-center justify-between hover:bg-orange-50 transition-colors"
            >
              <div className="min-w-0">
                <div className="font-medium text-sm text-[#0F172A] truncate">{quote.customer?.name || "Unknown"}</div>
                <div className="text-xs text-slate-500">{quote.from_postcode} → {quote.to_postcode}</div>
              </div>
              <span className="text-xs font-medium bg-orange-100 text-orange-700 px-2 py-0.5 rounded shrink-0 ml-2">
                {formatStatus(quote.status)}
              </span>
            </Link>
          ))}
        </div>
      </div>
    )}
  </div>
);
